// Dental Clinic OS localization dictionaries.
// Primary/default: Turkish (tr, LTR). Secondary: Arabic (ar, RTL).
// English (en) kept as a development fallback.

export const LANGUAGES = [
  { code: "tr", label: "Türkçe", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
];

export const DEFAULT_LANG = "tr";

export const translations = {
  tr: {
    nav: {
      owner: "Sahip Paneli", operations: "Operasyonlar", patients: "Hastalar",
      appointments: "Randevular", laboratory: "Laboratuvar", travel: "Seyahat",
      transportation: "Ulaşım", payments: "Ödemeler", cashDrawer: "Kasa",
      exchangeRates: "Döviz Kurları", pricing: "Fiyatlandırma & Maliyet",
      accounting: "Muhasebe", payables: "Ödenecekler", finance: "Banka & Giderler",
      approvals: "İndirim & İadeler", journey: "Hasta Yolculuğu", messages: "Mesajlar",
      reports: "Raporlar", employees: "Çalışanlar", permissions: "Yetki Merkezi",
      audit: "Denetim Kayıtları", driver: "Şoför Paneli",
    },
    common: {
      signOut: "Çıkış Yap", search: "Ara", save: "Kaydet", saveChanges: "Değişiklikleri Kaydet",
      cancel: "İptal", create: "Oluştur", edit: "Düzenle", delete: "Sil", approve: "Onayla",
      reject: "Reddet", apply: "Uygula", add: "Ekle", close: "Kapat", remove: "Kaldır",
      loading: "Yükleniyor…", status: "Durum", date: "Tarih", amount: "Tutar",
      currency: "Para Birimi", actions: "İşlemler", total: "Toplam", type: "Tür", name: "Ad",
      method: "Yöntem", reason: "Gerekçe", vendor: "Tedarikçi", optional: "İsteğe bağlı",
      language: "Dil", view: "Görüntüle", download: "İndir", upload: "Yükle",
      export: "Dışa Aktar", submit: "Gönder", generate: "Oluştur", from: "Başlangıç",
      to: "Bitiş", all: "Tümü", none: "Yok", today: "Bugün", pending: "Beklemede",
      active: "Aktif", inactive: "Pasif", notifications: "Bildirimler",
      noData: "Kayıt bulunamadı", back: "Geri", exportFailed: "Dışa aktarma başarısız",
      copied: "Kopyalandı", units: "birim", visit: "Ziyaret",
    },
    roles: {
      owner: "Sahip", operations_manager: "Operasyon Müdürü",
      supervising_dentist: "Sorumlu Diş Hekimi", treating_dentist: "Tedavi Eden Diş Hekimi",
      coordination: "Koordinasyon", translator_cashier: "Tercüman / Kasiyer",
      medical_secretary: "Tıbbi Sekreter", general_accountant: "Genel Muhasebeci",
      laboratory_coordinator: "Laboratuvar Koordinatörü",
      laboratory_technician: "Laboratuvar Teknisyeni", driver: "Şoför",
    },
    stages: {
      registration: "Kayıt", preliminary_quotation: "Ön Teklif", travel_planning: "Seyahat Planlama",
      arrival: "Varış", reception: "Karşılama", medical_examination: "Tıbbi Muayene",
      treatment_plan_approved: "Tedavi Planı Onaylandı", dentist_assigned: "Diş Hekimi Atandı",
      appointments: "Randevular", laboratory_production: "Laboratuvar Üretimi", treatment: "Tedavi",
      payments: "Ödemeler", ready_for_pickup: "Alınmaya Hazır", driver_notified: "Şoför Bilgilendirildi",
      transportation: "Ulaşım", follow_up: "Takip", completed: "Tamamlandı",
    },
    auth: {
      title: "Diş Kliniği İşletim Sistemi", username: "Kullanıcı Adı",
      password: "Şifre", login: "Giriş Yap", activateOwner: "Sahip hesabını etkinleştir",
      activate: "Hesabı etkinleştir", mfaCode: "Doğrulama Kodu",
      heroTitle: "Tüm klinik için tek entegre sistem.",
      heroSub: "Koordinasyon, klinik, laboratuvar, seyahat ve finans genelinde bireysel personel hesapları, yapılandırılabilir yetkiler ve denetlenen erişim.",
      secured: "Şifre karması ve doğrulayıcı MFA ile güvende",
      useAccount: "Bireysel personel hesabınızı kullanın.", passwordPlaceholder: "Şifrenizi girin",
      ownerActivated: "Sahip hesabı zaten etkinleştirilmiş. Yukarıdan giriş yapın.",
      firstTimeEmployee: "İlk kez mi? Hesabınızı bir kodla etkinleştirin",
    },
    dashboard: {
      ownerTitle: "Sahip Paneli",
      ownerSubtitle: "Klinik performans özeti · gerçek rakamlar EUR cinsinden",
      opsTitle: "Operasyon Paneli", opsSubtitle: "Canlı klinik, laboratuvar ve ulaşım durumu",
      live: "Canlı", synthetic: "Örnek veri", periodMonth: "Bu Ay", periodQuarter: "Çeyrek",
      periodYtd: "Yıl Başından Bugüne", periodAll: "Tüm Zamanlar",
      earnedRevenue: "Tahakkuk Eden Gelir", cashCollections: "Tahsilatlar",
      receivables: "Alacaklar", margin: "Katkı Marjı", cashOnHand: "Kasadaki Nakit",
      bankBalance: "Banka Bakiyesi", revenueVsCollections: "Gelir ve Tahsilat",
      last6Months: "Son 6 ay (EUR)", costBreakdown: "Maliyet Dağılımı",
      totalPatients: "Toplam Hasta", activeStaff: "Aktif Personel",
      operatingExpenses: "İşletme Giderleri",
      costDoctorFees: "Doktor Ücretleri", costLaboratory: "Laboratuvar", costTravel: "Seyahat",
      costOperating: "İşletme", costTechnicians: "Teknisyenler",
    },
    ops: {
      inClinic: "Klinikteki Hastalar", awaiting: "Muayene Bekleyen", inTreatment: "Tedavide",
      labInProduction: "Üretimdeki Lab", labDelays: "Laboratuvar Gecikmeleri",
      readyForPickup: "Alınmaya Hazır", inTransit: "Yoldaki Araçlar",
      awaitingTransport: "Ulaşım Bekleyen", upcomingFlights: "Yaklaşan Uçuşlar",
      travelConflicts: "Seyahat Çakışmaları", completedTrips: "Tamamlanan Yolculuklar",
      cashDiscrepancies: "Kasa Farkları", journeyDistribution: "Hasta Yolculuğu Dağılımı",
      arrivalLog: "Hasta Varış Kaydı", alert: "Uyarı", min: "dk",
      noArrivals: "Bugün henüz hasta varışı yok",
      arrivalsHint: "Bir hasta teslim edildiğinde veya giriş yaptığında güncellenir",
      arrived: "Geldi", waitingForDentist: "Diş Hekimi Bekliyor", visitCompleted: "Ziyaret Tamamlandı",
      overdue: "Eşik süresini aştı — diş hekimi gerekiyor", manualCheckin: "Manuel giriş",
      driverDelivery: "Şoför teslimatı", noAppointment: "Randevu planlanmadı",
      appointment: "Randevu",
    },
    patients: {
      title: "Hastalar", subtitle: "Tüm departmanlar genelinde birleşik hasta kayıtları",
      register: "Hasta Kaydet", registerNew: "Yeni Hasta Kaydet",
      registerDesc: "Otomatik atanan bir kodla birleşik hasta kaydı oluşturur.",
      firstName: "Ad", lastName: "Soyad", dob: "Doğum Tarihi", gender: "Cinsiyet",
      phone: "Telefon", email: "E-posta", country: "Ülke", patientLanguage: "Dil", notes: "Notlar",
      searchPlaceholder: "Hasta ara...", code: "Kod", patientName: "Ad Soyad",
      journeyStage: "Yolculuk Aşaması", notFound: "Hasta bulunamadı",
      registered: "Hasta kaydedildi", loadError: "Hasta yüklenemedi", updated: "Hasta güncellendi",
      backToList: "Hastalara dön", clinicStatus: "Klinik durumu", notArrived: "Henüz gelmedi",
      readyForTransport: "Ulaşıma hazır", patientArrived: "Hasta Geldi", patientReady: "Hasta Hazır",
      arrivalRecorded: "Varış kaydedildi", markedReady: "Ulaşıma hazır olarak işaretlendi",
      personalContact: "Kişisel & İletişim", journeyFollowup: "Yolculuk & Takip",
    },
    appointments: {
      title: "Randevular", subtitle: "Doktor & koltuk çakışma kontrolü ile birleşik takvim",
      day: "Gün", week: "Hafta", new: "Yeni", schedule: "Randevu Planla",
      scheduleDesc: "Çakışan doktor veya koltuk rezervasyonları otomatik olarak engellenir.",
      patient: "Hasta", dentist: "Diş Hekimi", chair: "Koltuk", start: "Başlangıç", end: "Bitiş",
      translator: "Tercüman", visit: "Ziyaret", type: "Tür", selectPatient: "Hasta seç",
      selectPatientDentist: "Bir hasta ve diş hekimi seçin", scheduled: "planlandı",
      conflict: "Çakışma", noAppointments: "şu tarihte randevu yok:", startTreatment: "Tedaviye Başla",
      finishVisit: "Ziyareti Bitir", checkIn: "Giriş yap", complete: "Tamamla",
      treatmentStarted: "Tedavi başladı", visitCompleted: "Ziyaret tamamlandı",
      marked: "İşaretlendi", status_scheduled: "planlandı", status_checked_in: "giriş yapıldı",
      status_completed: "tamamlandı", status_cancelled: "iptal edildi",
      waitingForDentist: "Diş Hekimi Bekliyor", inTreatment: "Tedavide",
    },
    clinical: {
      treatmentPlans: "Tedavi Planları", procedures: "İşlemler", appointments: "Randevular",
      noAppointments: "Randevu yok", newPlan: "Yeni Plan / Teklif", newPlanTitle: "Yeni Tedavi Planı",
      newPlanDesc: "Ön teklifler, tıbbi olarak onaylanmış plandan ayrı tutulur.",
      preliminaryQuotation: "Ön Teklif", approvedPlan: "Onaylı Tedavi Planı (klinisyen)",
      procedure: "İşlem", tooth: "Diş", qty: "Adet", unit: "Birim €", addLine: "Satır ekle",
      savePlan: "Planı kaydet", planSaved: "Tedavi planı kaydedildi", addProcFirst: "En az bir işlem ekleyin",
      approve: "Onayla", planApproved: "Plan onaylandı", convertToPlan: "Plana dönüştür",
      converted: "Onaylı tedavi planına dönüştürüldü", noPlans: "Henüz tedavi planı yok",
      approvedPlanLabel: "Onaylı Plan", by: "Oluşturan", approvedBy: "Onaylayan",
      recordProcedure: "İşlem Kaydet", recordProcDesc: "Planlanan ile gerçekten yapılan işlemleri ayırt edin.",
      teeth: "Diş / dişler", unitsCrowns: "Birim / kron", shade: "Renk", status: "Durum",
      planned: "Planlandı", performed: "Yapıldı", techInstructions: "Teknik talimatlar (lab için)",
      record: "Kaydet", procRecorded: "İşlem kaydedildi", selectProc: "Bir işlem seçin",
      noProcs: "Kaydedilmiş işlem yok", markPerformed: "Yapıldı işaretle", markedPerformed: "Yapıldı olarak işaretlendi",
      photo: "Fotoğraf", photoUploaded: "Fotoğraf yüklendi", requestLab: "Lab İste",
      labRequested: "Lab işi istendi", unassigned: "Atanmamış", performedBy: "yapan",
      photosAttached: "fotoğraf ekli", lab: "Lab", select: "Seç",
    },
    lab: {
      title: "İç Laboratuvar", subtitle: "Üretim siparişleri, teknisyenler, kalite kontrol ve envanter",
      orders: "Siparişler", inventory: "Envanter", dashboard: "Panel", newOrder: "Yeni Lab Siparişi",
      newOrderTitle: "Yeni Laboratuvar Siparişi",
      newOrderDesc: "Teknik sipariş — laboratuvar personeline hasta fiyatı gösterilmez.",
      selectPatient: "Hasta seç", restorationType: "Restorasyon türü", toothNumbers: "Diş numaraları",
      material: "Malzeme", shade: "Renk", quantity: "Adet", responsibleDentist: "Sorumlu diş hekimi",
      requiredDate: "İstenen teslim tarihi", expectedCompletion: "Beklenen tamamlanma",
      createOrder: "Sipariş oluştur", orderCreated: "Lab siparişi oluşturuldu",
      noOrders: "Laboratuvar siparişi yok", delayed: "Gecikti", deadlineConflict: "Son teslim çakışması",
      unassigned: "Atanmamış", requiredBy: "İstenen", expected: "Beklenen", reworkCount: "Yeniden işleme",
      materialCost: "Malzeme maliyeti", measurementWorkflow: "Ölçüm iş akışı", received: "Alındı",
      measurementsReceived: "Ölçüler Alındı", instructions: "Talimatlar", clinicalPhotos: "Klinik fotoğraflar",
      assignedTechnician: "Atanan teknisyen", assignTechnician: "Teknisyen ata",
      advanceTo: "İlerlet:", qcPass: "KK Geçti", qcReject: "KK Reddet", deliverToClinic: "Kliniğe teslim et",
      crownsUnits: "Kronlar / Birimler", internal: "İç", external: "Dış", externalEllipsis: "Dış…",
      vendorName: "Dış tedarikçi adı", assign: "Ata", productionTimeline: "Üretim zaman çizelgesi",
      selectPatientErr: "Bir hasta seçin", openPhotoErr: "Fotoğraf açılamadı",
      stage_order_received: "Sipariş Alındı", stage_design: "Tasarım", stage_manufacturing: "Üretim",
      stage_finishing: "Son İşlem", stage_quality_control: "Kalite Kontrol",
      stage_ready_for_delivery: "Teslime Hazır", stage_delivered: "Teslim Edildi",
      invMaterial: "Malzeme", invSku: "SKU", invStock: "Stok", invReorder: "Yeniden sipariş",
      invUnitCost: "Birim maliyet", invStatus: "Durum", lowStock: "Düşük stok", ok: "Uygun",
      consume: "1 Tüket", consumed: "Tüketildi", activeOrders: "Aktif Siparişler",
      completedOrders: "Tamamlanan", delayedOrders: "Geciken", deadlineConflicts: "Son Teslim Çakışmaları",
      lowStockMaterials: "Düşük Stoklu Malzemeler", productionCosts: "Üretim Maliyetleri",
      ordersPerTech: "Teknisyen Başına Aktif Sipariş", noActiveOrders: "Aktif sipariş yok", unit: "Birim",
    },
    travel: {
      title: "Seyahat Yönetimi", subtitle: "Hasta başına uçuşlar, oteller ve güvenli seyahat belgeleri",
      selectPatient: "Hasta seç", flights: "Uçuşlar", hotels: "Oteller",
      documents: "Seyahat Belgeleri", docsHint: "(özel, şifreli depolama)",
      noFlights: "Uçuş kaydı yok", noHotels: "Otel rezervasyonu yok", noDocs: "Yüklenmiş belge yok",
      arrival: "varış", departure: "kalkış", terminal: "Terminal", room: "Oda",
      addFlight: "Uçuş Ekle", addFlightDesc: "Varış veya kalkış uçuş bilgileri.", direction: "Yön",
      airline: "Havayolu", flightNo: "Uçuş No.", fromIata: "Nereden (IATA)", toIata: "Nereye (IATA)",
      time: "Saat", add: "Ekle", addFlightBtn: "Uçuş ekle", flightAdded: "Uçuş eklendi",
      selectDate: "Bir tarih seçin", flightRemoved: "Uçuş kaldırıldı",
      addHotel: "Otel Ekle", addHotelDesc: "Bu hastaya bağlı konaklama.", hotelName: "Otel adı",
      address: "Adres", confirmation: "Onay #", checkIn: "Giriş", checkOut: "Çıkış", phone: "Telefon",
      addHotelBtn: "Otel ekle", hotelAdded: "Otel eklendi", hotelNameReq: "Otel adı gereklidir",
      hotelRemoved: "Otel kaldırıldı", upload: "Yükle", docUploaded: "Belge güvenli şekilde yüklendi",
      docRemoved: "Belge kaldırıldı", openDocErr: "Belge açılamadı",
    },
    transport: {
      title: "Ulaşım", subtitle: "Şoförler, araçlar & yolculuk planlama", trips: "Yolculuklar",
      vehicles: "Araçlar", scheduleTrip: "Yolculuk Planla",
      scheduleTripDesc: "90 dakika içinde şoför & araç çifte rezervasyonu otomatik engellenir.",
      patient: "Hasta", driver: "Şoför", vehicle: "Araç", type: "Tür", date: "Tarih", time: "Saat",
      pickup: "Alış yeri", dropoff: "Bırakış yeri", schedule: "Planla", tripScheduled: "Yolculuk planlandı",
      requiredFields: "Hasta, şoför ve tarih gereklidir", conflict: "Çakışma", noTrips: "Planlanmış yolculuk yok",
      complete: "Tamamla", cancel: "İptal", marked: "İşaretlendi", tripDeleted: "Yolculuk silindi",
      addVehicle: "Araç Ekle", addVehicleDesc: "Hasta transferleri için filo aracı.", plate: "Plaka",
      makeModel: "Marka & model", capacity: "Kapasite", color: "Renk", plateReq: "Plaka gereklidir",
      vehicleAdded: "Araç eklendi", vehicleRemoved: "Araç kaldırıldı", noVehicles: "Araç yok",
      seats: "koltuk", available: "müsait",
      t_airport_pickup: "Havaalanı karşılama", t_airport_dropoff: "Havaalanı bırakma",
      t_hotel_to_clinic: "Otel → Klinik", t_clinic_to_hotel: "Klinik → Otel", t_other: "Diğer",
    },
    payments: {
      title: "Ödemeler", subtitle: "Yüz yüze nakit & kart defteri · EUR / USD / TRY / GBP",
      patient: "Hasta", record: "Kaydet", recordPayment: "Ödeme Kaydet",
      recordDesc: "Belgeler beklemede olsa bile ödemeler kaydedilir.",
      amount: "Tutar", currency: "Para Birimi", method: "Yöntem", posReference: "POS referansı",
      notes: "Notlar", recordPaymentBtn: "Ödemeyi kaydet", enterAmount: "Bir tutar girin",
      paymentRecorded: "Ödeme kaydedildi", noPassportWarn: "Dosyada pasaport yok — takip için işaretlendi (ödeme yine de kaydedildi)",
      ledger: "Finansal Defter", treatmentClosed: "Tedavi mali olarak kapatıldı",
      closeTreatment: "Tedaviyi kapat (mali)", treatmentFinClosed: "Tedavi mali olarak kapatıldı",
      cannotClose: "Kapatılamaz —", stillOutstanding: "hâlâ ödenmedi", noPlanYet: "Henüz onaylı tedavi planı yok — bakiye plan onaylanınca görünür.",
      agreedAmount: "Anlaşılan tutar", discounts: "İndirimler", amountDue: "Ödenecek tutar",
      paidNet: "Ödenen (net)", balance: "Bakiye", includesRefunds: "İadeler dahil",
      balanceEurBase: "Bakiye (EUR bazlı)", passportDoc: "Pasaport belgesi",
      onFile: "Dosyada", notOnFile: "Dosyada yok — takip için işaretlendi", passportStored: "Pasaport güvenli şekilde saklandı",
      openPassportErr: "Pasaport açılamadı", noPayments: "Ödeme kaydedilmedi",
      receiptReady: "Fiş hazır", evidencePending: "Kanıt bekleniyor", receipt: "Fiş",
      generate: "Oluştur", receiptGenerated: "Fiş oluşturuldu", receiptNotAvailable: "Fiş mevcut değil",
      m_cash: "Nakit", m_credit_card: "Kredi Kartı", m_debit_card: "Banka Kartı",
    },
    cash: {
      title: "Kasa", subtitle: "Çoklu para birimi kasiyer vardiyaları & günlük mutabakat",
      openShift: "Vardiya aç", openingCash: "Açılış nakit tutarı", primaryCurrency: "Birincil kasa para birimi",
      openShiftBtn: "Vardiya aç", shiftOpened: "Vardiya açıldı", activeShift: "Aktif vardiya",
      openSince: "Açık:", currency: "Para Birimi", opening: "Açılış", cashReceived: "Alınan nakit",
      cardInfo: "Kart (bilgi)", outflows: "Çıkışlar", expected: "Beklenen",
      consolidatedExpected: "Konsolide beklenen (EUR bazlı)", recordOutflow: "Nakit çıkışı kaydet",
      amount: "Tutar", reason: "Gerekçe", outflowRecorded: "Nakit çıkışı kaydedildi",
      closeReconcile: "Kapat & mutabık kıl (her para birimini say)", counted: "Sayılan", exp: "bkl",
      closeShiftBtn: "Vardiyayı kapat", shiftClosed: "Vardiya kapatıldı · EUR farkı",
      enterCounted: "Şunun için sayılan nakdi girin:", allShifts: "Tüm vardiyalar", myShifts: "Vardiyalarım",
      cashier: "Kasiyer", opened: "Açılış", status: "Durum", currencies: "Para Birimleri",
      expectedEur: "Beklenen (EUR)", actualEur: "Gerçek (EUR)", varianceEur: "Fark (EUR)",
      noShifts: "Henüz vardiya yok", open: "açık", closed: "kapalı", var: "fark",
    },
    fx: {
      title: "Döviz Kurları", subtitle: "Yönetim tarafından yönetilen döviz · EUR bazlı · tarihli & denetlenir",
      currentRates: "Güncel kurlar (1 birim = EUR)", base: "baz", setNewRate: "Yeni geçerli kur belirle",
      setRateHint: "Yeni bir geçerli satır oluşturur — geçmiş asla üzerine yazılmaz.",
      currency: "Para Birimi", rateInEur: "EUR cinsinden kur", enterPositive: "Pozitif bir kur girin",
      rateEffective: "kuru şimdi geçerli", rateHistory: "Kur geçmişi", rate: "Kur (EUR)",
      effectiveFrom: "Geçerlilik başlangıcı", setBy: "Belirleyen", noHistory: "Geçmiş yok",
    },
    pricing: {
      title: "Fiyatlandırma & Maliyet Yapılandırması",
      subtitle: "Gizli muhasebe oranları · tarihli · asla üzerine yazılmaz · tam denetlenir",
      lockNote: "Oranlar €0 ile başlar ve yetkili yönetim gerçek değerleri girene kadar muhasebe tutarı oluşturmaz.",
      c_clinic: "Klinik Muhasebesi", c_doctor_comp: "Doktor Ücretlendirme",
      c_internal_lab: "İç Laboratuvar", c_external_lab: "Dış Laboratuvar",
      item: "Kalem", currentRate: "Güncel kur (EUR)", effectiveFrom: "Geçerlilik başlangıcı",
      newRate: "Yeni kur", reason: "Gerekçe", reasonOptional: "gerekçe (isteğe bağlı)",
      enterValidRate: "Geçerli bir kur girin", rateSaved: "Yeni geçerli kur kaydedildi",
      historyTitle: "Kur geçmişi ·", historyDesc: "Her geçerli kur korunur ve asla üzerine yazılmaz.",
      rate: "Kur", effective: "Geçerlilik", by: "Yapan", inactive: "(pasif)",
    },
    accounting: {
      title: "Muhasebe Raporları",
      subtitle: "Doğrulanmış tamamlanan işlerden üç bağımsız defter · EUR bazlı · gizli",
      c_clinic: "Klinik", c_doctor_comp: "Doktor Ücreti", c_internal_lab: "İç Lab",
      c_external_lab: "Dış Lab", c_consolidated: "Konsolide", from: "Başlangıç", to: "Bitiş",
      apply: "Uygula", verifiedUnits: "Doğrulanmış birimler", total: "toplam",
      date: "Tarih", patient: "Hasta", item: "Kalem", qty: "Adet", rate: "Kur", amount: "Tutar",
      providerLab: "Sağlayıcı / Lab", noEntries: "Bu dönemde doğrulanmış kayıt yok",
      clinicRevenue: "Klinik Geliri", doctorCompensation: "Doktor Ücretlendirme",
      internalLab: "İç Laboratuvar", externalLab: "Dış Laboratuvar", totalCost: "Toplam Maliyet",
      grossMargin: "Brüt Marj", noEntriesShort: "Kayıt yok", units: "birim",
    },
    payables: {
      title: "Ödenecekler & Bordro Beyanları",
      subtitle: "Doğrulanmış işlerden doktor & laboratuvar ücretleri · Tahakkuk → Onay → Ödendi",
      generateStatement: "Beyan oluştur", type: "Tür", beneficiary: "Hak sahibi", from: "Başlangıç",
      to: "Bitiş", generate: "Oluştur", selectBeneficiary: "Bir hak sahibi seçin",
      statementGenerated: "Beyan oluşturuldu", noneAvailable: "Mevcut değil", allTypes: "Tüm türler",
      period: "Dönem", earned: "Kazanılan", net: "Net", paid: "Ödenen", outstanding: "Kalan",
      status: "Durum", noStatements: "Henüz beyan yok", view: "görüntüle",
      t_doctor_comp: "Doktor Ücretlendirme", t_internal_lab: "İç Laboratuvar", t_external_lab: "Dış Laboratuvar",
      statement: "beyan", adjustments: "Düzeltmeler", noVerifiedWork: "Dönemde doğrulanmış iş yok",
      adjustmentTrail: "Düzeltme denetim izi", payments: "Ödemeler", drawerLinked: "kasaya bağlı",
      approve: "Onayla", approved: "Onaylandı", adjustment: "Düzeltme", applyAdj: "Uygula",
      adjusted: "Düzeltildi", recordPayment: "Ödeme kaydet", pay: "Öde", paymentRecorded: "Ödeme kaydedildi",
      s_accrued: "tahakkuk", s_approved: "onaylandı", s_paid: "ödendi",
      m_cash: "Nakit (açık kasadan)", m_bank_transfer: "Banka havalesi", m_credit_card: "Kart",
    },
    finance: {
      title: "Banka & Giderler", subtitle: "Gider defteri, banka hesapları ve maliyet kategorileri · EUR bazlı · denetlenir",
      expenses: "Giderler", banks: "Banka Hesapları", categories: "Kategoriler", report: "Rapor",
      recordExpense: "Gider kaydet", category: "Kategori", amount: "Tutar", currency: "Para Birimi",
      date: "Tarih", paidFrom: "Ödeme kaynağı", bank: "Banka", cashDrawer: "Kasa",
      bankAccount: "Banka hesabı", vendor: "Tedarikçi", receiptOptional: "Fiş (isteğe bağlı)",
      add: "Ekle", catAmountReq: "Kategori ve tutar gereklidir", selectBank: "Bir banka hesabı seçin",
      expenseRecorded: "Gider kaydedildi", cancelReason: "Bu gideri iptal etme gerekçesi?",
      expenseCancelled: "Gider iptal edildi", noExpenses: "Henüz gider yok", paidFromCol: "Ödeme kaynağı",
      status: "Durum", cancelled: "iptal edildi", active: "aktif",
      newBankAccount: "Yeni banka hesabı", accountName: "Ad", opening: "Açılış", create: "Oluştur",
      accountNameReq: "Hesap adı gereklidir", accountCreated: "Hesap oluşturuldu",
      manualTxn: "Manuel işlem", account: "Hesap", deposit: "Yatırma", withdrawal: "Çekme",
      post: "Gönder", accountAmountReq: "Hesap ve tutar gereklidir", txnPosted: "İşlem kaydedildi",
      noBankAccounts: "Henüz banka hesabı yok", openingShort: "Açılış",
      newCategory: "Yeni kategori", dashboardGroup: "Panel grubu", operating: "İşletme", travel: "Seyahat",
      nameReq: "Ad gereklidir", categoryAdded: "Kategori eklendi", group: "Grup",
      activate: "Etkinleştir", deactivate: "Devre dışı bırak", active: "Aktif", inactive: "Pasif",
      totalExpenses: "Toplam Giderler", byCategory: "Kategoriye Göre", bySource: "Banka Hesabı / Kaynağa Göre",
      noExpensesRange: "Bu aralıkta gider yok",
    },
    approvals: {
      title: "İndirim & İadeler", subtitle: "Tek onaylı iş akışı · kendi kendine onay yok · çift yürütme yok",
      allStatuses: "Tüm durumlar", allPatients: "Tüm hastalar", request: "Talep",
      newRequest: "Yeni Talep", newRequestDesc: "Yetkili bir onaylayıcı (siz değil) tarafından onay gerektirir.",
      patient: "Hasta", type: "Tür", currency: "Para Birimi", amount: "Tutar", reason: "Gerekçe",
      submitRequest: "Talep gönder", requiredFields: "Hasta ve tutar gereklidir",
      requestSubmitted: "Talep gönderildi", noRequests: "Talep yok",
      discount: "İndirim", refund: "İade", requestedBy: "Talep eden", approvedBy: "onaylayan",
      executedBy: "yürüten", approve: "Onayla", execute: "Yürüt",
      s_pending: "beklemede", s_approved: "onaylandı", s_executed: "yürütüldü", s_rejected: "reddedildi",
    },
    journey: {
      title: "Hasta Yolculuğu", subtitle: "Birleşik operasyonel görünüm · koordinasyon → klinik → lab → seyahat → ulaşım",
      selectPatient: "Hasta seç", timeline: "Hasta Yolculuğu Zaman Çizelgesi", noEvents: "Henüz yolculuk olayı yok.",
    },
    messages: {
      title: "Mesajlar", subtitle: "Güvenli dahili personel mesajlaşması", new: "Yeni",
      newConversation: "Yeni Sohbet", selectColleague: "Meslektaş seç", start: "Başlat",
      noConversations: "Sohbet yok", noMessages: "Henüz mesaj yok", selectConversation: "Bir sohbet seçin",
      typeMessage: "Bir mesaj yazın…",
    },
    reports: {
      title: "Raporlar", subtitle: "Muhasebe & operasyonel raporlama", daily: "Günlük",
      monthly: "Aylık Kapanış", visits: "Ziyaret Süreleri", noReport: "Rapor mevcut değil",
      completedVisits: "Tamamlanan ziyaretler", totalVisits: "Toplam ziyaret", avgWaiting: "Ort. bekleme",
      longestWaiting: "En uzun bekleme", avgTreatment: "Ort. tedavi", patient: "Hasta", visit: "Ziyaret",
      type: "Tür", dentist: "Diş Hekimi", scheduled: "Planlanan", arrived: "Geldi", waited: "Bekledi",
      treatStart: "Tedavi başl.", treatDur: "Tedavi süre.", completed: "Tamamlandı",
      noVisits: "Bu güne ait ziyaret yok", date: "Tarih", eachIndependent: "Her ziyaret bağımsızdır · Örnek geliştirme verisi.",
      revenueEur: "Gelir (EUR)", cashCollected: "Nakit tahsilat", cardCollected: "Kart tahsilat",
      refunds: "İadeler", discounts: "İndirimler", doctorEarnings: "Doktor kazançları",
      technicianEarnings: "Teknisyen kazançları", labCosts: "Lab maliyetleri", netEur: "Net (EUR)",
      netTry: "Net (TRY yasal)", bankSettlements: "Banka mutabakatları", cashBalance: "Kasa bakiyesi",
      collectionsByCurrency: "Para birimine göre tahsilat", noPayments: "Ödeme yok", txn: "işlem",
      posReconciliation: "POS mutabakatı", cardPayments: "Kart ödemeleri", matchedPos: "Eşleşen POS referansı",
      missingPos: "Eksik POS referansı", discrepancies: "Farklar", noneDisc: "Yok", month: "Ay",
      ratesToEur: "EUR'ya kurlar", syntheticData: "Örnek geliştirme verisi.",
    },
    employees: {
      title: "Çalışanlar", subtitle: "Bireysel personel hesapları, roller ve erişim kontrolü",
      addEmployee: "Çalışan Ekle", createAccount: "Çalışan Hesabı Oluştur",
      createAccountDesc: "Benzersiz tek kullanımlık bir etkinleştirme kodu oluşturulur. Çalışan bunu bir kez kullanarak kendi özel şifresini belirler.",
      username: "Kullanıcı Adı", fullName: "Ad Soyad", email: "E-posta", role: "Rol", selectRole: "Rol seç",
      createAccountBtn: "Hesap oluştur", selectRoleErr: "Bir rol seçin", employeeCreated: "Çalışan oluşturuldu",
      accountDeactivated: "Hesap devre dışı bırakıldı · oturumlar iptal edildi", accountEnabled: "Hesap etkinleştirildi",
      mfaReset: "MFA sıfırlandı", mainCoordApplied: "Ana Koordinatör profili uygulandı",
      codeIssued: "Yeni etkinleştirme kodu verildi", name: "Ad", status: "Durum", mfa: "MFA",
      disabled: "Devre dışı", active: "Aktif", pendingActivation: "Etkinleştirme bekliyor",
      enrolled: "Kayıtlı", required: "Gerekli", issueCode: "Etkinleştirme kodu ver",
      resetMfa: "MFA sıfırla", makeMainCoord: "Ana Koordinatör Yap", mainCoord: "Ana Koordinatör ✓",
      deactivate: "Devre dışı bırak", activate: "Etkinleştir",
      shareSecurely: "Çalışanla güvenli şekilde paylaşın. Yalnızca bir kez gösterilir — kendi şifresini belirlemek için kullanır.",
      activationCode: "Etkinleştirme kodu",
      phone: "Telefon", phonePlaceholder: "örn. +90 532 000 00 00",
      edit: "Düzenle", editAccount: "Çalışanı Düzenle",
      editAccountDesc: "Ad, e-posta, telefon ve rolü güncelleyin. Yetkili bir role geçişte MFA otomatik olarak gerekli olur.",
      saveChanges: "Değişiklikleri kaydet", employeeUpdated: "Çalışan güncellendi",
      rolesLoadError: "Roller yüklenemedi. Oturum veya bağlantı sorunu olabilir — lütfen sayfayı yenileyin.",
    },
    permissions: {
      title: "Yetki Merkezi", subtitle: "Her çalışanın tam olarak neyi görüntüleyebileceğini, oluşturabileceğini, düzenleyebileceğini, onaylayabileceğini, yürütebileceğini ve dışa aktarabileceğini yapılandırın",
      selectEmployee: "Bir çalışan seçin", editing: "Düzenleniyor",
      labBlocked: ". Laboratuvar rolleri mali verilerden kalıcı olarak engellenir.",
      resource: "Kaynak", financial: "mali", permissionsUpdated: "Yetkiler güncellendi · oturumlar yenilendi",
      a_view: "görüntüle", a_create: "oluştur", a_edit: "düzenle", a_approve: "onayla",
      a_execute: "yürüt", a_export: "dışa aktar",
    },
    audit: {
      title: "Denetim & Etkinlik", subtitle: "Her işlem sorumlu çalışana atfedilir",
      auditLog: "Denetim Kaydı", loginHistory: "Giriş Geçmişi", permissionChanges: "Yetki Değişiklikleri",
      time: "Zaman", employee: "Çalışan", action: "İşlem", entity: "Varlık", ip: "IP",
      username: "Kullanıcı Adı", result: "Sonuç", success: "Başarılı", failed: "Başarısız",
      changedBy: "Değiştiren", targetEmployee: "Hedef Çalışan", overrides: "Geçersiz Kılmalar",
      rules: "kural", noRecords: "Kayıt yok",
    },
    driver: {
      myTrips: "Yolculuklarım", online: "Çevrimiçi", offline: "Çevrimdışı",
      noTrips: "Size atanmış yolculuk yok.", hotelNotSet: "Otel belirlenmedi",
      pickedUp: "Alındı", delivered: "Teslim edildi", patientPickedUp: "Hasta Alındı",
      patientDelivered: "Hasta Teslim Edildi", tripCompleted: "Yolculuk tamamlandı",
      tripCancelled: "Yolculuk iptal edildi", pickupRecorded: "Alış kaydedildi",
      deliveryRecorded: "Teslimat kaydedildi — yolculuk tamamlandı", offlineErr: "Çevrimdışısınız — yeniden bağlanıp tekrar deneyin.",
      networkErr: "Ağ hatası — lütfen tekrar deneyin.",
      s_scheduled: "Planlandı", s_en_route_pickup: "Yolda", s_arrived_pickup: "Vardı",
      s_passenger_onboard: "Alındı", s_completed: "Teslim Edildi", s_cancelled: "İptal Edildi",
    },
    notif: {
      title: "Bildirimler", markAll: "Tümünü okundu işaretle", allCaughtUp: "Hepsi tamam.",
      waiting: "diş hekimi için", waitingMin: "dk bekliyor (eşik", unassigned: "Atanmamış", visit: "Ziyaret",
    },
  },

  ar: {
    nav: {
      owner: "لوحة المالك", operations: "العمليات", patients: "المرضى",
      appointments: "المواعيد", laboratory: "المختبر", travel: "السفر",
      transportation: "النقل", payments: "المدفوعات", cashDrawer: "الصندوق",
      exchangeRates: "أسعار الصرف", pricing: "التسعير والتكاليف",
      accounting: "المحاسبة", payables: "المستحقات", finance: "البنوك والمصاريف",
      approvals: "الخصومات والمستردات", journey: "رحلة المريض", messages: "الرسائل",
      reports: "التقارير", employees: "الموظفون", permissions: "مركز الصلاحيات",
      audit: "سجلات التدقيق", driver: "لوحة السائق",
    },
    common: {
      signOut: "تسجيل الخروج", search: "بحث", save: "حفظ", saveChanges: "حفظ التغييرات",
      cancel: "إلغاء", create: "إنشاء", edit: "تعديل", delete: "حذف", approve: "موافقة",
      reject: "رفض", apply: "تطبيق", add: "إضافة", close: "إغلاق", remove: "إزالة",
      loading: "جار التحميل…", status: "الحالة", date: "التاريخ", amount: "المبلغ",
      currency: "العملة", actions: "الإجراءات", total: "الإجمالي", type: "النوع", name: "الاسم",
      method: "الطريقة", reason: "السبب", vendor: "المورّد", optional: "اختياري",
      language: "اللغة", view: "عرض", download: "تنزيل", upload: "رفع",
      export: "تصدير", submit: "إرسال", generate: "إنشاء", from: "من", to: "إلى",
      all: "الكل", none: "لا شيء", today: "اليوم", pending: "قيد الانتظار",
      active: "نشط", inactive: "غير نشط", notifications: "الإشعارات",
      noData: "لا توجد سجلات", back: "رجوع", exportFailed: "فشل التصدير",
      copied: "تم النسخ", units: "وحدة", visit: "زيارة",
    },
    roles: {
      owner: "المالك", operations_manager: "مدير العمليات",
      supervising_dentist: "طبيب الأسنان المشرف", treating_dentist: "طبيب الأسنان المعالج",
      coordination: "التنسيق", translator_cashier: "مترجم / أمين صندوق",
      medical_secretary: "السكرتير الطبي", general_accountant: "المحاسب العام",
      laboratory_coordinator: "منسق المختبر",
      laboratory_technician: "فني المختبر", driver: "السائق",
    },
    stages: {
      registration: "التسجيل", preliminary_quotation: "عرض سعر أولي", travel_planning: "تخطيط السفر",
      arrival: "الوصول", reception: "الاستقبال", medical_examination: "الفحص الطبي",
      treatment_plan_approved: "تمت الموافقة على خطة العلاج", dentist_assigned: "تم تعيين الطبيب",
      appointments: "المواعيد", laboratory_production: "إنتاج المختبر", treatment: "العلاج",
      payments: "المدفوعات", ready_for_pickup: "جاهز للاستلام", driver_notified: "تم إبلاغ السائق",
      transportation: "النقل", follow_up: "المتابعة", completed: "مكتمل",
    },
    auth: {
      title: "نظام تشغيل عيادة الأسنان", username: "اسم المستخدم",
      password: "كلمة المرور", login: "تسجيل الدخول", activateOwner: "تفعيل حساب المالك",
      activate: "تفعيل الحساب", mfaCode: "رمز التحقق",
      heroTitle: "نظام متكامل واحد للعيادة بأكملها.",
      heroSub: "حسابات موظفين فردية وصلاحيات قابلة للتهيئة ووصول مُدقّق عبر التنسيق والعيادة والمختبر والسفر والمالية.",
      secured: "محمي بتجزئة كلمة المرور ومصادقة MFA",
      useAccount: "استخدم حساب الموظف الخاص بك.", passwordPlaceholder: "أدخل كلمة المرور",
      ownerActivated: "تم تفعيل حساب المالك بالفعل. سجّل الدخول من الأعلى.",
      firstTimeEmployee: "موظف لأول مرة؟ فعّل حسابك برمز",
    },
    dashboard: {
      ownerTitle: "لوحة المالك", ownerSubtitle: "نظرة عامة على أداء العيادة · الأرقام الفعلية باليورو",
      opsTitle: "لوحة العمليات", opsSubtitle: "حالة العيادة والمختبر والنقل المباشرة",
      live: "مباشر", synthetic: "بيانات تجريبية", periodMonth: "هذا الشهر", periodQuarter: "ربع سنوي",
      periodYtd: "منذ بداية السنة", periodAll: "كل الأوقات",
      earnedRevenue: "الإيرادات المستحقة", cashCollections: "التحصيلات",
      receivables: "الذمم المدينة", margin: "هامش المساهمة", cashOnHand: "النقد المتاح",
      bankBalance: "رصيد البنك", revenueVsCollections: "الإيرادات مقابل التحصيلات",
      last6Months: "آخر 6 أشهر (يورو)", costBreakdown: "توزيع التكاليف",
      totalPatients: "إجمالي المرضى", activeStaff: "الموظفون النشطون",
      operatingExpenses: "المصاريف التشغيلية",
      costDoctorFees: "أتعاب الأطباء", costLaboratory: "المختبر", costTravel: "السفر",
      costOperating: "تشغيلي", costTechnicians: "الفنيون",
    },
    ops: {
      inClinic: "المرضى في العيادة", awaiting: "بانتظار الفحص", inTreatment: "قيد العلاج",
      labInProduction: "المختبر قيد الإنتاج", labDelays: "تأخيرات المختبر",
      readyForPickup: "جاهز للاستلام", inTransit: "المركبات في الطريق",
      awaitingTransport: "بانتظار النقل", upcomingFlights: "الرحلات القادمة",
      travelConflicts: "تعارضات السفر", completedTrips: "الرحلات المكتملة",
      cashDiscrepancies: "فروقات الصندوق", journeyDistribution: "توزيع رحلة المريض",
      arrivalLog: "سجل وصول المرضى", alert: "تنبيه", min: "دقيقة",
      noArrivals: "لا يوجد وصول مرضى اليوم بعد",
      arrivalsHint: "يتم التحديث عند تسليم مريض أو تسجيل دخوله",
      arrived: "وصل", waitingForDentist: "بانتظار الطبيب", visitCompleted: "اكتملت الزيارة",
      overdue: "تجاوز الحد — يحتاج إلى طبيب", manualCheckin: "تسجيل دخول يدوي",
      driverDelivery: "توصيل السائق", noAppointment: "لا يوجد موعد مجدول", appointment: "موعد",
    },
    patients: {
      title: "المرضى", subtitle: "سجلات مرضى موحدة عبر جميع الأقسام",
      register: "تسجيل مريض", registerNew: "تسجيل مريض جديد",
      registerDesc: "ينشئ سجل مريض موحد برمز يُعيَّن تلقائياً.",
      firstName: "الاسم الأول", lastName: "اسم العائلة", dob: "تاريخ الميلاد", gender: "الجنس",
      phone: "الهاتف", email: "البريد الإلكتروني", country: "الدولة", patientLanguage: "اللغة", notes: "ملاحظات",
      searchPlaceholder: "ابحث عن مريض...", code: "الرمز", patientName: "الاسم",
      journeyStage: "مرحلة الرحلة", notFound: "لم يُعثر على مرضى",
      registered: "تم تسجيل المريض", loadError: "تعذر تحميل المريض", updated: "تم تحديث المريض",
      backToList: "العودة إلى المرضى", clinicStatus: "حالة العيادة", notArrived: "لم يصل بعد",
      readyForTransport: "جاهز للنقل", patientArrived: "وصل المريض", patientReady: "المريض جاهز",
      arrivalRecorded: "تم تسجيل الوصول", markedReady: "تم تحديده كجاهز للنقل",
      personalContact: "البيانات الشخصية والاتصال", journeyFollowup: "الرحلة والمتابعة",
    },
    appointments: {
      title: "المواعيد", subtitle: "تقويم موحد مع كشف تعارض الطبيب والكرسي",
      day: "يوم", week: "أسبوع", new: "جديد", schedule: "جدولة موعد",
      scheduleDesc: "يتم حظر حجوزات الطبيب أو الكرسي المتداخلة تلقائياً.",
      patient: "المريض", dentist: "طبيب الأسنان", chair: "الكرسي", start: "البداية", end: "النهاية",
      translator: "مترجم", visit: "زيارة", type: "النوع", selectPatient: "اختر مريضاً",
      selectPatientDentist: "اختر مريضاً وطبيباً", scheduled: "تمت الجدولة",
      conflict: "تعارض", noAppointments: "لا مواعيد في", startTreatment: "بدء العلاج",
      finishVisit: "إنهاء الزيارة", checkIn: "تسجيل الدخول", complete: "إكمال",
      treatmentStarted: "بدأ العلاج", visitCompleted: "اكتملت الزيارة", marked: "تم التحديد",
      status_scheduled: "مجدول", status_checked_in: "تم تسجيل الدخول",
      status_completed: "مكتمل", status_cancelled: "ملغى",
      waitingForDentist: "بانتظار الطبيب", inTreatment: "قيد العلاج",
    },
    clinical: {
      treatmentPlans: "خطط العلاج", procedures: "الإجراءات", appointments: "المواعيد",
      noAppointments: "لا مواعيد", newPlan: "خطة / عرض سعر جديد", newPlanTitle: "خطة علاج جديدة",
      newPlanDesc: "تبقى عروض الأسعار الأولية منفصلة عن الخطة المعتمدة طبياً.",
      preliminaryQuotation: "عرض سعر أولي", approvedPlan: "خطة علاج معتمدة (طبيب)",
      procedure: "الإجراء", tooth: "السن", qty: "الكمية", unit: "الوحدة €", addLine: "إضافة سطر",
      savePlan: "حفظ الخطة", planSaved: "تم حفظ خطة العلاج", addProcFirst: "أضف إجراءً واحداً على الأقل",
      approve: "موافقة", planApproved: "تمت الموافقة على الخطة", convertToPlan: "تحويل إلى خطة",
      converted: "تم التحويل إلى خطة علاج معتمدة", noPlans: "لا توجد خطط علاج بعد",
      approvedPlanLabel: "خطة معتمدة", by: "بواسطة", approvedBy: "اعتمدها",
      recordProcedure: "تسجيل إجراء", recordProcDesc: "ميّز بين الإجراءات المخططة والمنفذة فعلياً.",
      teeth: "السن / الأسنان", unitsCrowns: "الوحدات / التيجان", shade: "اللون", status: "الحالة",
      planned: "مخطط", performed: "منفذ", techInstructions: "تعليمات فنية (للمختبر)",
      record: "تسجيل", procRecorded: "تم تسجيل الإجراء", selectProc: "اختر إجراءً",
      noProcs: "لا إجراءات مسجلة", markPerformed: "تحديد كمنفذ", markedPerformed: "تم تحديده كمنفذ",
      photo: "صورة", photoUploaded: "تم رفع الصورة", requestLab: "طلب مختبر",
      labRequested: "تم طلب عمل المختبر", unassigned: "غير معيّن", performedBy: "نفّذه",
      photosAttached: "صورة مرفقة", lab: "مختبر", select: "اختر",
    },
    lab: {
      title: "المختبر الداخلي", subtitle: "أوامر الإنتاج والفنيون ومراقبة الجودة والمخزون",
      orders: "الأوامر", inventory: "المخزون", dashboard: "اللوحة", newOrder: "أمر مختبر جديد",
      newOrderTitle: "أمر مختبر جديد",
      newOrderDesc: "أمر فني — لا تُعرض أسعار المرضى لموظفي المختبر.",
      selectPatient: "اختر مريضاً", restorationType: "نوع الترميم", toothNumbers: "أرقام الأسنان",
      material: "المادة", shade: "اللون", quantity: "الكمية", responsibleDentist: "الطبيب المسؤول",
      requiredDate: "تاريخ التسليم المطلوب", expectedCompletion: "الإكمال المتوقع",
      createOrder: "إنشاء أمر", orderCreated: "تم إنشاء أمر المختبر",
      noOrders: "لا توجد أوامر مختبر", delayed: "متأخر", deadlineConflict: "تعارض الموعد النهائي",
      unassigned: "غير معيّن", requiredBy: "مطلوب في", expected: "متوقع", reworkCount: "إعادة العمل",
      materialCost: "تكلفة المادة", measurementWorkflow: "سير عمل القياس", received: "مستلم",
      measurementsReceived: "تم استلام القياسات", instructions: "التعليمات", clinicalPhotos: "صور سريرية",
      assignedTechnician: "الفني المعيّن", assignTechnician: "تعيين فني",
      advanceTo: "التقدم إلى", qcPass: "نجاح الجودة", qcReject: "رفض الجودة", deliverToClinic: "تسليم للعيادة",
      crownsUnits: "التيجان / الوحدات", internal: "داخلي", external: "خارجي", externalEllipsis: "خارجي…",
      vendorName: "اسم المورّد الخارجي", assign: "تعيين", productionTimeline: "الجدول الزمني للإنتاج",
      selectPatientErr: "اختر مريضاً", openPhotoErr: "تعذر فتح الصورة",
      stage_order_received: "تم استلام الأمر", stage_design: "التصميم", stage_manufacturing: "التصنيع",
      stage_finishing: "التشطيب", stage_quality_control: "مراقبة الجودة",
      stage_ready_for_delivery: "جاهز للتسليم", stage_delivered: "تم التسليم",
      invMaterial: "المادة", invSku: "SKU", invStock: "المخزون", invReorder: "إعادة الطلب",
      invUnitCost: "تكلفة الوحدة", invStatus: "الحالة", lowStock: "مخزون منخفض", ok: "جيد",
      consume: "استهلاك 1", consumed: "تم الاستهلاك", activeOrders: "الأوامر النشطة",
      completedOrders: "مكتمل", delayedOrders: "متأخر", deadlineConflicts: "تعارضات المواعيد النهائية",
      lowStockMaterials: "مواد منخفضة المخزون", productionCosts: "تكاليف الإنتاج",
      ordersPerTech: "الأوامر النشطة لكل فني", noActiveOrders: "لا أوامر نشطة", unit: "وحدة",
    },
    travel: {
      title: "إدارة السفر", subtitle: "الرحلات والفنادق ووثائق السفر الآمنة لكل مريض",
      selectPatient: "اختر مريضاً", flights: "الرحلات", hotels: "الفنادق",
      documents: "وثائق السفر", docsHint: "(تخزين خاص ومشفّر)",
      noFlights: "لا رحلات مسجلة", noHotels: "لا حجوزات فنادق", noDocs: "لا وثائق مرفوعة",
      arrival: "وصول", departure: "مغادرة", terminal: "المبنى", room: "الغرفة",
      addFlight: "إضافة رحلة", addFlightDesc: "تفاصيل رحلة الوصول أو المغادرة.", direction: "الاتجاه",
      airline: "شركة الطيران", flightNo: "رقم الرحلة", fromIata: "من (IATA)", toIata: "إلى (IATA)",
      time: "الوقت", add: "إضافة", addFlightBtn: "إضافة رحلة", flightAdded: "تمت إضافة الرحلة",
      selectDate: "اختر تاريخاً", flightRemoved: "تمت إزالة الرحلة",
      addHotel: "إضافة فندق", addHotelDesc: "إقامة مرتبطة بهذا المريض.", hotelName: "اسم الفندق",
      address: "العنوان", confirmation: "رقم التأكيد", checkIn: "تسجيل الوصول", checkOut: "تسجيل المغادرة", phone: "الهاتف",
      addHotelBtn: "إضافة فندق", hotelAdded: "تمت إضافة الفندق", hotelNameReq: "اسم الفندق مطلوب",
      hotelRemoved: "تمت إزالة الفندق", upload: "رفع", docUploaded: "تم رفع الوثيقة بأمان",
      docRemoved: "تمت إزالة الوثيقة", openDocErr: "تعذر فتح الوثيقة",
    },
    transport: {
      title: "النقل", subtitle: "السائقون والمركبات وجدولة الرحلات", trips: "الرحلات",
      vehicles: "المركبات", scheduleTrip: "جدولة رحلة",
      scheduleTripDesc: "يتم حظر الحجز المزدوج للسائق والمركبة خلال 90 دقيقة تلقائياً.",
      patient: "المريض", driver: "السائق", vehicle: "المركبة", type: "النوع", date: "التاريخ", time: "الوقت",
      pickup: "مكان الاستلام", dropoff: "مكان التوصيل", schedule: "جدولة", tripScheduled: "تمت جدولة الرحلة",
      requiredFields: "المريض والسائق والتاريخ مطلوبة", conflict: "تعارض", noTrips: "لا رحلات مجدولة",
      complete: "إكمال", cancel: "إلغاء", marked: "تم التحديد", tripDeleted: "تم حذف الرحلة",
      addVehicle: "إضافة مركبة", addVehicleDesc: "مركبة الأسطول المستخدمة لنقل المرضى.", plate: "اللوحة",
      makeModel: "الصنع والطراز", capacity: "السعة", color: "اللون", plateReq: "اللوحة مطلوبة",
      vehicleAdded: "تمت إضافة المركبة", vehicleRemoved: "تمت إزالة المركبة", noVehicles: "لا مركبات",
      seats: "مقاعد", available: "متاح",
      t_airport_pickup: "استقبال المطار", t_airport_dropoff: "توصيل المطار",
      t_hotel_to_clinic: "الفندق → العيادة", t_clinic_to_hotel: "العيادة → الفندق", t_other: "أخرى",
    },
    payments: {
      title: "المدفوعات", subtitle: "دفتر النقد والبطاقات الحضوري · EUR / USD / TRY / GBP",
      patient: "المريض", record: "تسجيل", recordPayment: "تسجيل دفعة",
      recordDesc: "تُسجَّل المدفوعات حتى لو كانت الوثائق معلقة.",
      amount: "المبلغ", currency: "العملة", method: "الطريقة", posReference: "مرجع نقطة البيع",
      notes: "ملاحظات", recordPaymentBtn: "تسجيل الدفعة", enterAmount: "أدخل مبلغاً",
      paymentRecorded: "تم تسجيل الدفعة", noPassportWarn: "لا يوجد جواز سفر في الملف — تم وضع علامة للمتابعة (الدفعة مسجلة)",
      ledger: "الدفتر المالي", treatmentClosed: "تم إغلاق العلاج مالياً",
      closeTreatment: "إغلاق العلاج (مالياً)", treatmentFinClosed: "تم إغلاق العلاج مالياً",
      cannotClose: "لا يمكن الإغلاق —", stillOutstanding: "لا يزال مستحقاً", noPlanYet: "لا توجد خطة علاج معتمدة بعد — يظهر الرصيد عند اعتماد الخطة.",
      agreedAmount: "المبلغ المتفق عليه", discounts: "الخصومات", amountDue: "المبلغ المستحق",
      paidNet: "المدفوع (صافي)", balance: "الرصيد", includesRefunds: "يشمل المستردات",
      balanceEurBase: "الرصيد (أساس اليورو)", passportDoc: "وثيقة جواز السفر",
      onFile: "في الملف", notOnFile: "غير موجود — تم وضع علامة للمتابعة", passportStored: "تم حفظ جواز السفر بأمان",
      openPassportErr: "تعذر فتح جواز السفر", noPayments: "لا مدفوعات مسجلة",
      receiptReady: "الإيصال جاهز", evidencePending: "الإثبات معلق", receipt: "إيصال",
      generate: "إنشاء", receiptGenerated: "تم إنشاء الإيصال", receiptNotAvailable: "الإيصال غير متاح",
      m_cash: "نقد", m_credit_card: "بطاقة ائتمان", m_debit_card: "بطاقة خصم",
    },
    cash: {
      title: "الصندوق", subtitle: "ورديات أمين الصندوق متعددة العملات والتسوية اليومية",
      openShift: "فتح وردية", openingCash: "مبلغ النقد الافتتاحي", primaryCurrency: "العملة الأساسية للصندوق",
      openShiftBtn: "فتح وردية", shiftOpened: "تم فتح الوردية", activeShift: "الوردية النشطة",
      openSince: "مفتوحة منذ", currency: "العملة", opening: "الافتتاح", cashReceived: "النقد المستلم",
      cardInfo: "البطاقة (معلومات)", outflows: "المصروفات", expected: "المتوقع",
      consolidatedExpected: "المتوقع الموحد (أساس اليورو)", recordOutflow: "تسجيل مصروف نقدي",
      amount: "المبلغ", reason: "السبب", outflowRecorded: "تم تسجيل المصروف النقدي",
      closeReconcile: "إغلاق وتسوية (عُدّ كل عملة)", counted: "المعدود", exp: "متوقع",
      closeShiftBtn: "إغلاق الوردية", shiftClosed: "تم إغلاق الوردية · فرق اليورو",
      enterCounted: "أدخل النقد المعدود لـ", allShifts: "كل الورديات", myShifts: "ورديّاتي",
      cashier: "أمين الصندوق", opened: "فُتحت", status: "الحالة", currencies: "العملات",
      expectedEur: "المتوقع (يورو)", actualEur: "الفعلي (يورو)", varianceEur: "الفرق (يورو)",
      noShifts: "لا ورديات بعد", open: "مفتوحة", closed: "مغلقة", var: "فرق",
    },
    fx: {
      title: "أسعار الصرف", subtitle: "صرف تديره الإدارة · أساس اليورو · مؤرخ ومدقق",
      currentRates: "الأسعار الحالية (1 وحدة = يورو)", base: "أساس", setNewRate: "تعيين سعر جديد ساري",
      setRateHint: "ينشئ صفاً سارياً جديداً — لا يُكتب فوق التاريخ أبداً.",
      currency: "العملة", rateInEur: "السعر باليورو", enterPositive: "أدخل سعراً موجباً",
      rateEffective: "السعر ساري الآن", rateHistory: "سجل الأسعار", rate: "السعر (يورو)",
      effectiveFrom: "ساري من", setBy: "حدّده", noHistory: "لا يوجد سجل",
    },
    pricing: {
      title: "تكوين التسعير والتكاليف",
      subtitle: "أسعار محاسبية سرية · مؤرخة · لا يُكتب فوقها أبداً · مدققة بالكامل",
      lockNote: "تبدأ الأسعار من €0 ولا تُنشئ أي مبلغ محاسبي حتى تُدخل الإدارة المخولة قيماً حقيقية.",
      c_clinic: "محاسبة العيادة", c_doctor_comp: "تعويض الطبيب",
      c_internal_lab: "المختبر الداخلي", c_external_lab: "المختبر الخارجي",
      item: "البند", currentRate: "السعر الحالي (يورو)", effectiveFrom: "ساري من",
      newRate: "سعر جديد", reason: "السبب", reasonOptional: "السبب (اختياري)",
      enterValidRate: "أدخل سعراً صالحاً", rateSaved: "تم حفظ السعر الساري الجديد",
      historyTitle: "سجل الأسعار ·", historyDesc: "كل سعر ساري محفوظ ولا يُكتب فوقه أبداً.",
      rate: "السعر", effective: "ساري", by: "بواسطة", inactive: "(غير نشط)",
    },
    accounting: {
      title: "تقارير المحاسبة",
      subtitle: "ثلاثة دفاتر مستقلة من الأعمال المكتملة المتحقق منها · أساس اليورو · سري",
      c_clinic: "العيادة", c_doctor_comp: "تعويض الطبيب", c_internal_lab: "مختبر داخلي",
      c_external_lab: "مختبر خارجي", c_consolidated: "موحد", from: "من", to: "إلى",
      apply: "تطبيق", verifiedUnits: "الوحدات المتحقق منها", total: "الإجمالي",
      date: "التاريخ", patient: "المريض", item: "البند", qty: "الكمية", rate: "السعر", amount: "المبلغ",
      providerLab: "المزوّد / المختبر", noEntries: "لا قيود متحقق منها في هذه الفترة",
      clinicRevenue: "إيرادات العيادة", doctorCompensation: "تعويض الطبيب",
      internalLab: "المختبر الداخلي", externalLab: "المختبر الخارجي", totalCost: "إجمالي التكلفة",
      grossMargin: "الهامش الإجمالي", noEntriesShort: "لا قيود", units: "وحدة",
    },
    payables: {
      title: "المستحقات وكشوف الرواتب",
      subtitle: "تعويضات الأطباء والمختبر من الأعمال المتحقق منها · مستحق → معتمد → مدفوع",
      generateStatement: "إنشاء كشف", type: "النوع", beneficiary: "المستفيد", from: "من",
      to: "إلى", generate: "إنشاء", selectBeneficiary: "اختر مستفيداً",
      statementGenerated: "تم إنشاء الكشف", noneAvailable: "لا يوجد متاح", allTypes: "كل الأنواع",
      period: "الفترة", earned: "المكتسب", net: "صافي", paid: "مدفوع", outstanding: "المتبقي",
      status: "الحالة", noStatements: "لا كشوف بعد", view: "عرض",
      t_doctor_comp: "تعويض الطبيب", t_internal_lab: "المختبر الداخلي", t_external_lab: "المختبر الخارجي",
      statement: "كشف", adjustments: "التعديلات", noVerifiedWork: "لا عمل متحقق منه في الفترة",
      adjustmentTrail: "سجل تدقيق التعديلات", payments: "المدفوعات", drawerLinked: "مرتبط بالصندوق",
      approve: "موافقة", approved: "معتمد", adjustment: "تعديل", applyAdj: "تطبيق",
      adjusted: "تم التعديل", recordPayment: "تسجيل دفعة", pay: "دفع", paymentRecorded: "تم تسجيل الدفعة",
      s_accrued: "مستحق", s_approved: "معتمد", s_paid: "مدفوع",
      m_cash: "نقد (من الصندوق المفتوح)", m_bank_transfer: "تحويل بنكي", m_credit_card: "بطاقة",
    },
    finance: {
      title: "البنوك والمصاريف", subtitle: "دفتر المصاريف والحسابات البنكية وفئات التكلفة · أساس اليورو · مدقق",
      expenses: "المصاريف", banks: "الحسابات البنكية", categories: "الفئات", report: "تقرير",
      recordExpense: "تسجيل مصروف", category: "الفئة", amount: "المبلغ", currency: "العملة",
      date: "التاريخ", paidFrom: "مدفوع من", bank: "بنك", cashDrawer: "صندوق النقد",
      bankAccount: "حساب بنكي", vendor: "المورّد", receiptOptional: "إيصال (اختياري)",
      add: "إضافة", catAmountReq: "الفئة والمبلغ مطلوبان", selectBank: "اختر حساباً بنكياً",
      expenseRecorded: "تم تسجيل المصروف", cancelReason: "سبب إلغاء هذا المصروف؟",
      expenseCancelled: "تم إلغاء المصروف", noExpenses: "لا مصاريف بعد", paidFromCol: "مدفوع من",
      status: "الحالة", cancelled: "ملغى", active: "نشط",
      newBankAccount: "حساب بنكي جديد", accountName: "الاسم", opening: "الافتتاح", create: "إنشاء",
      accountNameReq: "اسم الحساب مطلوب", accountCreated: "تم إنشاء الحساب",
      manualTxn: "معاملة يدوية", account: "الحساب", deposit: "إيداع", withdrawal: "سحب",
      post: "ترحيل", accountAmountReq: "الحساب والمبلغ مطلوبان", txnPosted: "تم ترحيل المعاملة",
      noBankAccounts: "لا حسابات بنكية بعد", openingShort: "الافتتاح",
      newCategory: "فئة جديدة", dashboardGroup: "مجموعة اللوحة", operating: "تشغيلي", travel: "سفر",
      nameReq: "الاسم مطلوب", categoryAdded: "تمت إضافة الفئة", group: "المجموعة",
      activate: "تفعيل", deactivate: "إلغاء التفعيل", active: "نشط", inactive: "غير نشط",
      totalExpenses: "إجمالي المصاريف", byCategory: "حسب الفئة", bySource: "حسب الحساب البنكي / المصدر",
      noExpensesRange: "لا مصاريف في النطاق",
    },
    approvals: {
      title: "الخصومات والمستردات", subtitle: "سير عمل باعتماد واحد · لا اعتماد ذاتي · لا تنفيذ مكرر",
      allStatuses: "كل الحالات", allPatients: "كل المرضى", request: "طلب",
      newRequest: "طلب جديد", newRequestDesc: "يتطلب موافقة معتمد مخوّل (ليس أنت).",
      patient: "المريض", type: "النوع", currency: "العملة", amount: "المبلغ", reason: "السبب",
      submitRequest: "إرسال الطلب", requiredFields: "المريض والمبلغ مطلوبان",
      requestSubmitted: "تم إرسال الطلب", noRequests: "لا طلبات",
      discount: "خصم", refund: "استرداد", requestedBy: "طلبه", approvedBy: "اعتمده",
      executedBy: "نفّذه", approve: "موافقة", execute: "تنفيذ",
      s_pending: "قيد الانتظار", s_approved: "معتمد", s_executed: "منفّذ", s_rejected: "مرفوض",
    },
    journey: {
      title: "رحلة المريض", subtitle: "عرض تشغيلي موحد · التنسيق → العيادة → المختبر → السفر → النقل",
      selectPatient: "اختر مريضاً", timeline: "الجدول الزمني لرحلة المريض", noEvents: "لا أحداث رحلة بعد.",
    },
    messages: {
      title: "الرسائل", subtitle: "مراسلة داخلية آمنة للموظفين", new: "جديد",
      newConversation: "محادثة جديدة", selectColleague: "اختر زميلاً", start: "بدء",
      noConversations: "لا محادثات", noMessages: "لا رسائل بعد", selectConversation: "اختر محادثة",
      typeMessage: "اكتب رسالة…",
    },
    reports: {
      title: "التقارير", subtitle: "التقارير المحاسبية والتشغيلية", daily: "يومي",
      monthly: "الإقفال الشهري", visits: "مدد الزيارات", noReport: "لا يوجد تقرير متاح",
      completedVisits: "الزيارات المكتملة", totalVisits: "إجمالي الزيارات", avgWaiting: "متوسط الانتظار",
      longestWaiting: "أطول انتظار", avgTreatment: "متوسط العلاج", patient: "المريض", visit: "زيارة",
      type: "النوع", dentist: "الطبيب", scheduled: "مجدول", arrived: "وصل", waited: "انتظر",
      treatStart: "بدء العلاج", treatDur: "مدة العلاج", completed: "مكتمل",
      noVisits: "لا زيارات في هذا اليوم", date: "التاريخ", eachIndependent: "كل زيارة مستقلة · بيانات تطوير تجريبية.",
      revenueEur: "الإيراد (يورو)", cashCollected: "النقد المحصّل", cardCollected: "البطاقة المحصّلة",
      refunds: "المستردات", discounts: "الخصومات", doctorEarnings: "أرباح الأطباء",
      technicianEarnings: "أرباح الفنيين", labCosts: "تكاليف المختبر", netEur: "صافي (يورو)",
      netTry: "صافي (ليرة قانونية)", bankSettlements: "التسويات البنكية", cashBalance: "رصيد النقد",
      collectionsByCurrency: "التحصيلات حسب العملة", noPayments: "لا مدفوعات", txn: "معاملة",
      posReconciliation: "تسوية نقطة البيع", cardPayments: "مدفوعات البطاقة", matchedPos: "مرجع نقطة بيع مطابق",
      missingPos: "مرجع نقطة بيع مفقود", discrepancies: "الفروقات", noneDisc: "لا شيء", month: "الشهر",
      ratesToEur: "الأسعار إلى اليورو", syntheticData: "بيانات تطوير تجريبية.",
    },
    employees: {
      title: "الموظفون", subtitle: "حسابات الموظفين الفردية والأدوار والتحكم بالوصول",
      addEmployee: "إضافة موظف", createAccount: "إنشاء حساب موظف",
      createAccountDesc: "يتم إنشاء رمز تفعيل فريد لمرة واحدة. يستخدمه الموظف مرة واحدة لتعيين كلمة مروره الخاصة.",
      username: "اسم المستخدم", fullName: "الاسم الكامل", email: "البريد الإلكتروني", role: "الدور", selectRole: "اختر دوراً",
      createAccountBtn: "إنشاء الحساب", selectRoleErr: "اختر دوراً", employeeCreated: "تم إنشاء الموظف",
      accountDeactivated: "تم تعطيل الحساب · أُلغيت الجلسات", accountEnabled: "تم تفعيل الحساب",
      mfaReset: "تمت إعادة ضبط المصادقة", mainCoordApplied: "تم تطبيق ملف المنسق الرئيسي",
      codeIssued: "تم إصدار رمز تفعيل جديد", name: "الاسم", status: "الحالة", mfa: "المصادقة",
      disabled: "معطّل", active: "نشط", pendingActivation: "بانتظار التفعيل",
      enrolled: "مسجّل", required: "مطلوب", issueCode: "إصدار رمز تفعيل",
      resetMfa: "إعادة ضبط المصادقة", makeMainCoord: "جعله منسقاً رئيسياً", mainCoord: "المنسق الرئيسي ✓",
      deactivate: "تعطيل", activate: "تفعيل",
      shareSecurely: "شاركه بأمان مع الموظف. يُعرض مرة واحدة فقط — يستخدمه لتعيين كلمة مروره.",
      activationCode: "رمز التفعيل",
      phone: "الهاتف", phonePlaceholder: "مثال: ‎+90 532 000 00 00",
      edit: "تعديل", editAccount: "تعديل الموظف",
      editAccountDesc: "حدّث الاسم والبريد والهاتف والدور. عند التحويل إلى دور مميّز تصبح المصادقة الثنائية مطلوبة تلقائياً.",
      saveChanges: "حفظ التغييرات", employeeUpdated: "تم تحديث الموظف",
      rolesLoadError: "تعذّر تحميل الأدوار. قد تكون هناك مشكلة في الجلسة أو الاتصال — يرجى تحديث الصفحة.",
    },
    permissions: {
      title: "مركز الصلاحيات", subtitle: "حدد بالضبط ما يمكن لكل موظف عرضه وإنشاؤه وتعديله واعتماده وتنفيذه وتصديره",
      selectEmployee: "اختر موظفاً", editing: "تحرير",
      labBlocked: ". أدوار المختبر محظورة دائماً من البيانات المالية.",
      resource: "المورد", financial: "مالي", permissionsUpdated: "تم تحديث الصلاحيات · أُعيد تحديث الجلسات",
      a_view: "عرض", a_create: "إنشاء", a_edit: "تعديل", a_approve: "اعتماد",
      a_execute: "تنفيذ", a_export: "تصدير",
    },
    audit: {
      title: "التدقيق والنشاط", subtitle: "كل إجراء منسوب إلى الموظف المسؤول",
      auditLog: "سجل التدقiq", loginHistory: "سجل الدخول", permissionChanges: "تغييرات الصلاحيات",
      time: "الوقت", employee: "الموظف", action: "الإجراء", entity: "الكيان", ip: "IP",
      username: "اسم المستخدم", result: "النتيجة", success: "ناجح", failed: "فشل",
      changedBy: "غيّره", targetEmployee: "الموظف المستهدف", overrides: "التجاوزات",
      rules: "قاعدة", noRecords: "لا سجلات",
    },
    driver: {
      myTrips: "رحلاتي", online: "متصل", offline: "غير متصل",
      noTrips: "لا رحلات معيّنة لك.", hotelNotSet: "الفندق غير محدد",
      pickedUp: "تم الاستلام", delivered: "تم التوصيل", patientPickedUp: "تم استلام المريض",
      patientDelivered: "تم توصيل المريض", tripCompleted: "اكتملت الرحلة",
      tripCancelled: "أُلغيت الرحلة", pickupRecorded: "تم تسجيل الاستلام",
      deliveryRecorded: "تم تسجيل التوصيل — اكتملت الرحلة", offlineErr: "أنت غير متصل — أعد الاتصال وحاول مجدداً.",
      networkErr: "خطأ في الشبكة — يرجى المحاولة مجدداً.",
      s_scheduled: "مجدول", s_en_route_pickup: "في الطريق", s_arrived_pickup: "وصل",
      s_passenger_onboard: "تم الاستلام", s_completed: "تم التوصيل", s_cancelled: "ملغى",
    },
    notif: {
      title: "الإشعارات", markAll: "تحديد الكل كمقروء", allCaughtUp: "لا جديد لديك.",
      waiting: "للطبيب", waitingMin: "دقيقة انتظار (الحد", unassigned: "غير معيّن", visit: "زيارة",
    },
  },

  en: {
    nav: {
      owner: "Owner Dashboard", operations: "Operations", patients: "Patients",
      appointments: "Appointments", laboratory: "Laboratory", travel: "Travel",
      transportation: "Transportation", payments: "Payments", cashDrawer: "Cash Drawer",
      exchangeRates: "Exchange Rates", pricing: "Pricing & Costs", accounting: "Accounting",
      payables: "Payables", finance: "Bank & Expenses", approvals: "Discounts & Refunds",
      journey: "Patient Journey", messages: "Messages", reports: "Reports",
      employees: "Employees", permissions: "Permission Center", audit: "Audit Logs",
      driver: "Driver Dashboard",
    },
    common: {
      signOut: "Sign out", search: "Search", save: "Save", saveChanges: "Save changes",
      cancel: "Cancel", create: "Create", edit: "Edit", delete: "Delete", approve: "Approve",
      reject: "Reject", apply: "Apply", add: "Add", close: "Close", remove: "Remove",
      loading: "Loading…", status: "Status", date: "Date", amount: "Amount",
      currency: "Currency", actions: "Actions", total: "Total", type: "Type", name: "Name",
      method: "Method", reason: "Reason", vendor: "Vendor", optional: "Optional",
      language: "Language", view: "View", download: "Download", upload: "Upload",
      export: "Export", submit: "Submit", generate: "Generate", from: "From", to: "To",
      all: "All", none: "None", today: "Today", pending: "Pending",
      active: "Active", inactive: "Inactive", notifications: "Notifications",
      noData: "No records", back: "Back", exportFailed: "Export failed",
      copied: "Copied", units: "units", visit: "Visit",
    },
    roles: {
      owner: "Owner", operations_manager: "Operations Manager",
      supervising_dentist: "Supervising Dentist", treating_dentist: "Treating Dentist",
      coordination: "Coordination", translator_cashier: "Translator / Cashier",
      medical_secretary: "Medical Secretary", general_accountant: "General Accountant",
      laboratory_coordinator: "Laboratory Coordinator",
      laboratory_technician: "Laboratory Technician", driver: "Driver",
    },
    stages: {
      registration: "Registration", preliminary_quotation: "Preliminary Quotation", travel_planning: "Travel Planning",
      arrival: "Arrival", reception: "Reception", medical_examination: "Medical Examination",
      treatment_plan_approved: "Treatment Plan Approved", dentist_assigned: "Dentist Assigned",
      appointments: "Appointments", laboratory_production: "Laboratory Production", treatment: "Treatment",
      payments: "Payments", ready_for_pickup: "Ready for Pickup", driver_notified: "Driver Notified",
      transportation: "Transportation", follow_up: "Follow-up", completed: "Completed",
    },
    auth: {
      title: "Dental Clinic OS", username: "Username", password: "Password",
      login: "Sign in", activateOwner: "Activate the Owner account",
      activate: "Activate account", mfaCode: "Verification code",
      heroTitle: "One integrated system for the entire clinic.",
      heroSub: "Individual staff accounts, configurable permissions and audited access across coordination, clinical, laboratory, travel and finance.",
      secured: "Secured with password hashing & authenticator MFA",
      useAccount: "Use your individual staff account.", passwordPlaceholder: "Enter your password",
      ownerActivated: "The Owner account has already been activated. Sign in above.",
      firstTimeEmployee: "First-time employee? Activate your account with a code",
    },
    dashboard: {
      ownerTitle: "Owner Dashboard", ownerSubtitle: "Clinic performance overview · live figures reported in EUR",
      opsTitle: "Operations Dashboard", opsSubtitle: "Live clinic, laboratory and transport status",
      live: "Live", synthetic: "Synthetic data", periodMonth: "This Month", periodQuarter: "Quarter",
      periodYtd: "Year to Date", periodAll: "All Time", earnedRevenue: "Earned Revenue",
      cashCollections: "Cash Collections", receivables: "Receivables",
      margin: "Contribution Margin", cashOnHand: "Cash on Hand", bankBalance: "Bank Balance",
      revenueVsCollections: "Revenue vs Collections", last6Months: "Last 6 months (EUR)",
      costBreakdown: "Cost Breakdown", totalPatients: "Total Patients", activeStaff: "Active Staff",
      operatingExpenses: "Operating Expenses",
      costDoctorFees: "Doctor Fees", costLaboratory: "Laboratory", costTravel: "Travel",
      costOperating: "Operating", costTechnicians: "Technicians",
    },
    ops: {
      inClinic: "Patients In Clinic", awaiting: "Awaiting Examination", inTreatment: "In Treatment",
      labInProduction: "Lab In Production", labDelays: "Laboratory Delays",
      readyForPickup: "Ready For Pickup", inTransit: "Vehicles In Transit",
      awaitingTransport: "Awaiting Transport", upcomingFlights: "Upcoming Flights",
      travelConflicts: "Travel Conflicts", completedTrips: "Completed Trips",
      cashDiscrepancies: "Cash Discrepancies", journeyDistribution: "Patient Journey Distribution",
      arrivalLog: "Patient Arrival Log", alert: "Alert", min: "min",
      noArrivals: "No patient arrivals yet today",
      arrivalsHint: "Updates when a patient is delivered or checked in",
      arrived: "Arrived", waitingForDentist: "Waiting for Dentist", visitCompleted: "Visit Completed",
      overdue: "Waiting over threshold — needs a dentist", manualCheckin: "Manual check-in",
      driverDelivery: "Driver delivery", noAppointment: "No appointment scheduled", appointment: "Appointment",
    },
    patients: {
      title: "Patients", subtitle: "Unified patient records across all departments",
      register: "Register Patient", registerNew: "Register New Patient",
      registerDesc: "Creates a unified patient record with an auto-assigned code.",
      firstName: "First name", lastName: "Last name", dob: "Date of birth", gender: "Gender",
      phone: "Phone", email: "Email", country: "Country", patientLanguage: "Language", notes: "Notes",
      searchPlaceholder: "Search patients...", code: "Code", patientName: "Name",
      journeyStage: "Journey Stage", notFound: "No patients found",
      registered: "Patient registered", loadError: "Unable to load patient", updated: "Patient updated",
      backToList: "Back to patients", clinicStatus: "Clinic status", notArrived: "Not yet arrived",
      readyForTransport: "Ready for transport", patientArrived: "Patient Arrived", patientReady: "Patient Ready",
      arrivalRecorded: "Arrival recorded", markedReady: "Marked ready for transport",
      personalContact: "Personal & Contact", journeyFollowup: "Journey & Follow-up",
    },
    appointments: {
      title: "Appointments", subtitle: "Unified calendar with doctor & chair conflict detection",
      day: "Day", week: "Week", new: "New", schedule: "Schedule Appointment",
      scheduleDesc: "Overlapping doctor or chair bookings are automatically blocked.",
      patient: "Patient", dentist: "Dentist", chair: "Chair", start: "Start", end: "End",
      translator: "Translator", visit: "Visit", type: "Type", selectPatient: "Select patient",
      selectPatientDentist: "Select a patient and a dentist", scheduled: "scheduled",
      conflict: "Conflict", noAppointments: "No appointments on", startTreatment: "Start Treatment",
      finishVisit: "Finish Visit", checkIn: "Check in", complete: "Complete",
      treatmentStarted: "Treatment started", visitCompleted: "Visit completed", marked: "Marked",
      status_scheduled: "scheduled", status_checked_in: "checked in",
      status_completed: "completed", status_cancelled: "cancelled",
      waitingForDentist: "Waiting for Dentist", inTreatment: "In Treatment",
    },
    clinical: {
      treatmentPlans: "Treatment Plans", procedures: "Procedures", appointments: "Appointments",
      noAppointments: "No appointments", newPlan: "New Plan / Quotation", newPlanTitle: "New Treatment Plan",
      newPlanDesc: "Preliminary quotations stay separate from the medically approved plan.",
      preliminaryQuotation: "Preliminary Quotation", approvedPlan: "Approved Treatment Plan (clinician)",
      procedure: "Procedure", tooth: "Tooth", qty: "Qty", unit: "Unit €", addLine: "Add line",
      savePlan: "Save plan", planSaved: "Treatment plan saved", addProcFirst: "Add at least one procedure",
      approve: "Approve", planApproved: "Plan approved", convertToPlan: "Convert to plan",
      converted: "Converted to approved treatment plan", noPlans: "No treatment plans yet",
      approvedPlanLabel: "Approved Plan", by: "By", approvedBy: "Approved by",
      recordProcedure: "Record Procedure", recordProcDesc: "Distinguish planned from actually performed procedures.",
      teeth: "Tooth / teeth", unitsCrowns: "Units / crowns", shade: "Shade / colour", status: "Status",
      planned: "Planned", performed: "Performed", techInstructions: "Technical instructions (for lab)",
      record: "Record", procRecorded: "Procedure recorded", selectProc: "Select a procedure",
      noProcs: "No procedures recorded", markPerformed: "Mark performed", markedPerformed: "Marked performed",
      photo: "Photo", photoUploaded: "Photo uploaded", requestLab: "Request Lab",
      labRequested: "Lab work requested", unassigned: "Unassigned", performedBy: "performed by",
      photosAttached: "photo(s) attached", lab: "Lab", select: "Select",
    },
    lab: {
      title: "Internal Laboratory", subtitle: "Production orders, technicians, quality control and inventory",
      orders: "Orders", inventory: "Inventory", dashboard: "Dashboard", newOrder: "New Lab Order",
      newOrderTitle: "New Laboratory Order",
      newOrderDesc: "Technical order — no patient pricing is shown to laboratory staff.",
      selectPatient: "Select patient", restorationType: "Restoration type", toothNumbers: "Tooth numbers",
      material: "Material", shade: "Shade", quantity: "Quantity", responsibleDentist: "Responsible dentist",
      requiredDate: "Required delivery date", expectedCompletion: "Expected completion",
      createOrder: "Create order", orderCreated: "Lab order created",
      noOrders: "No laboratory orders", delayed: "Delayed", deadlineConflict: "Deadline conflict",
      unassigned: "Unassigned", requiredBy: "Required by", expected: "Expected", reworkCount: "Rework count",
      materialCost: "Material cost", measurementWorkflow: "Measurement workflow", received: "Received",
      measurementsReceived: "Measurements Received", instructions: "Instructions", clinicalPhotos: "Clinical photos",
      assignedTechnician: "Assigned technician", assignTechnician: "Assign technician",
      advanceTo: "Advance to", qcPass: "QC Pass", qcReject: "QC Reject", deliverToClinic: "Deliver to clinic",
      crownsUnits: "Crowns / Units", internal: "Internal", external: "External", externalEllipsis: "External…",
      vendorName: "External vendor name", assign: "Assign", productionTimeline: "Production timeline",
      selectPatientErr: "Select a patient", openPhotoErr: "Unable to open photo",
      stage_order_received: "Order Received", stage_design: "Design", stage_manufacturing: "Manufacturing",
      stage_finishing: "Finishing", stage_quality_control: "Quality Control",
      stage_ready_for_delivery: "Ready for Delivery", stage_delivered: "Delivered",
      invMaterial: "Material", invSku: "SKU", invStock: "Stock", invReorder: "Reorder",
      invUnitCost: "Unit cost", invStatus: "Status", lowStock: "Low stock", ok: "OK",
      consume: "Consume 1", consumed: "Consumed", activeOrders: "Active Orders",
      completedOrders: "Completed", delayedOrders: "Delayed", deadlineConflicts: "Deadline Conflicts",
      lowStockMaterials: "Low-stock Materials", productionCosts: "Production Costs",
      ordersPerTech: "Active Orders per Technician", noActiveOrders: "No active orders", unit: "Unit",
    },
    travel: {
      title: "Travel Management", subtitle: "Flights, hotels & secure travel documents per patient",
      selectPatient: "Select patient", flights: "Flights", hotels: "Hotels",
      documents: "Travel Documents", docsHint: "(private, encrypted storage)",
      noFlights: "No flights recorded", noHotels: "No hotel bookings", noDocs: "No documents uploaded",
      arrival: "arrival", departure: "departure", terminal: "Terminal", room: "Room",
      addFlight: "Add Flight", addFlightDesc: "Arrival or departure flight details.", direction: "Direction",
      airline: "Airline", flightNo: "Flight No.", fromIata: "From (IATA)", toIata: "To (IATA)",
      time: "Time", add: "Add", addFlightBtn: "Add flight", flightAdded: "Flight added",
      selectDate: "Select a date", flightRemoved: "Flight removed",
      addHotel: "Add Hotel", addHotelDesc: "Accommodation linked to this patient.", hotelName: "Hotel name",
      address: "Address", confirmation: "Confirmation #", checkIn: "Check-in", checkOut: "Check-out", phone: "Phone",
      addHotelBtn: "Add hotel", hotelAdded: "Hotel added", hotelNameReq: "Hotel name is required",
      hotelRemoved: "Hotel removed", upload: "Upload", docUploaded: "Document uploaded securely",
      docRemoved: "Document removed", openDocErr: "Unable to open document",
    },
    transport: {
      title: "Transportation", subtitle: "Drivers, vehicles & trip scheduling", trips: "Trips",
      vehicles: "Vehicles", scheduleTrip: "Schedule Trip",
      scheduleTripDesc: "Driver & vehicle double-booking within 90 minutes is blocked automatically.",
      patient: "Patient", driver: "Driver", vehicle: "Vehicle", type: "Type", date: "Date", time: "Time",
      pickup: "Pickup location", dropoff: "Drop-off location", schedule: "Schedule", tripScheduled: "Trip scheduled",
      requiredFields: "Patient, driver and date are required", conflict: "Conflict", noTrips: "No trips scheduled",
      complete: "Complete", cancel: "Cancel", marked: "Marked", tripDeleted: "Trip deleted",
      addVehicle: "Add Vehicle", addVehicleDesc: "Fleet vehicle used for patient transfers.", plate: "Plate",
      makeModel: "Make & model", capacity: "Capacity", color: "Color", plateReq: "Plate is required",
      vehicleAdded: "Vehicle added", vehicleRemoved: "Vehicle removed", noVehicles: "No vehicles",
      seats: "seats", available: "available",
      t_airport_pickup: "Airport pickup", t_airport_dropoff: "Airport drop-off",
      t_hotel_to_clinic: "Hotel → Clinic", t_clinic_to_hotel: "Clinic → Hotel", t_other: "Other",
    },
    payments: {
      title: "Payments", subtitle: "In-person cash & card ledger · EUR / USD / TRY / GBP",
      patient: "Patient", record: "Record", recordPayment: "Record Payment",
      recordDesc: "Payments are recorded even if documents are pending.",
      amount: "Amount", currency: "Currency", method: "Method", posReference: "POS reference",
      notes: "Notes", recordPaymentBtn: "Record payment", enterAmount: "Enter an amount",
      paymentRecorded: "Payment recorded", noPassportWarn: "No passport on file — flagged for follow-up (payment still recorded)",
      ledger: "Financial Ledger", treatmentClosed: "Treatment financially closed",
      closeTreatment: "Close treatment (financial)", treatmentFinClosed: "Treatment financially closed",
      cannotClose: "Cannot close —", stillOutstanding: "still outstanding", noPlanYet: "No approved treatment plan yet — balance appears once a plan is approved.",
      agreedAmount: "Agreed amount", discounts: "Discounts", amountDue: "Amount due",
      paidNet: "Paid (net)", balance: "Balance", includesRefunds: "Includes refunds",
      balanceEurBase: "Balance (EUR base)", passportDoc: "Passport document",
      onFile: "On file", notOnFile: "Not on file — flagged for follow-up", passportStored: "Passport stored securely",
      openPassportErr: "Unable to open passport", noPayments: "No payments recorded",
      receiptReady: "Receipt ready", evidencePending: "Evidence pending", receipt: "Receipt",
      generate: "Generate", receiptGenerated: "Receipt generated", receiptNotAvailable: "Receipt not available",
      m_cash: "Cash", m_credit_card: "Credit Card", m_debit_card: "Debit Card",
    },
    cash: {
      title: "Cash Drawer", subtitle: "Multi-currency cashier shifts & daily reconciliation",
      openShift: "Open a shift", openingCash: "Opening cash amount", primaryCurrency: "Primary drawer currency",
      openShiftBtn: "Open shift", shiftOpened: "Shift opened", activeShift: "Active shift",
      openSince: "Open since", currency: "Currency", opening: "Opening", cashReceived: "Cash received",
      cardInfo: "Card (info)", outflows: "Outflows", expected: "Expected",
      consolidatedExpected: "Consolidated expected (EUR base)", recordOutflow: "Record cash outflow",
      amount: "Amount", reason: "Reason", outflowRecorded: "Cash outflow recorded",
      closeReconcile: "Close & reconcile (count each currency)", counted: "Counted", exp: "exp",
      closeShiftBtn: "Close shift", shiftClosed: "Shift closed · EUR variance",
      enterCounted: "Enter counted cash for", allShifts: "All shifts", myShifts: "My shifts",
      cashier: "Cashier", opened: "Opened", status: "Status", currencies: "Currencies",
      expectedEur: "Expected (EUR)", actualEur: "Actual (EUR)", varianceEur: "Variance (EUR)",
      noShifts: "No shifts yet", open: "open", closed: "closed", var: "var",
    },
    fx: {
      title: "Exchange Rates", subtitle: "Admin-managed FX · EUR base · effective-dated & audited",
      currentRates: "Current rates (1 unit = EUR)", base: "base", setNewRate: "Set a new effective rate",
      setRateHint: "Creates a new effective row — history is never overwritten.",
      currency: "Currency", rateInEur: "Rate in EUR", enterPositive: "Enter a positive rate",
      rateEffective: "rate effective now", rateHistory: "Rate history", rate: "Rate (EUR)",
      effectiveFrom: "Effective from", setBy: "Set by", noHistory: "No history",
    },
    pricing: {
      title: "Pricing & Cost Configuration",
      subtitle: "Confidential accounting rates · effective-dated · never overwritten · fully audited",
      lockNote: "Rates start at €0 and generate no accounting amount until authorized management enters real values.",
      c_clinic: "Clinic Accounting", c_doctor_comp: "Doctor Compensation",
      c_internal_lab: "Internal Lab", c_external_lab: "External Lab",
      item: "Item", currentRate: "Current rate (EUR)", effectiveFrom: "Effective from",
      newRate: "New rate", reason: "Reason", reasonOptional: "reason (optional)",
      enterValidRate: "Enter a valid rate", rateSaved: "New effective rate saved",
      historyTitle: "Rate history ·", historyDesc: "Every effective rate is preserved and never overwritten.",
      rate: "Rate", effective: "Effective", by: "By", inactive: "(inactive)",
    },
    accounting: {
      title: "Accounting Reports",
      subtitle: "Three independent ledgers from verified completed work · EUR base · confidential",
      c_clinic: "Clinic", c_doctor_comp: "Doctor Comp.", c_internal_lab: "Internal Lab",
      c_external_lab: "External Lab", c_consolidated: "Consolidated", from: "From", to: "To",
      apply: "Apply", verifiedUnits: "Verified units", total: "total",
      date: "Date", patient: "Patient", item: "Item", qty: "Qty", rate: "Rate", amount: "Amount",
      providerLab: "Provider / Lab", noEntries: "No verified entries in this period",
      clinicRevenue: "Clinic Revenue", doctorCompensation: "Doctor Compensation",
      internalLab: "Internal Lab", externalLab: "External Lab", totalCost: "Total Cost",
      grossMargin: "Gross Margin", noEntriesShort: "No entries", units: "units",
    },
    payables: {
      title: "Payables & Payroll Statements",
      subtitle: "Doctor & laboratory compensation from verified work · Accrued → Approved → Paid",
      generateStatement: "Generate a statement", type: "Type", beneficiary: "Beneficiary", from: "From",
      to: "To", generate: "Generate", selectBeneficiary: "Select a beneficiary",
      statementGenerated: "Statement generated", noneAvailable: "None available", allTypes: "All types",
      period: "Period", earned: "Earned", net: "Net", paid: "Paid", outstanding: "Outstanding",
      status: "Status", noStatements: "No statements yet", view: "view",
      t_doctor_comp: "Doctor Compensation", t_internal_lab: "Internal Lab", t_external_lab: "External Lab",
      statement: "statement", adjustments: "Adjustments", noVerifiedWork: "No verified work in period",
      adjustmentTrail: "Adjustment audit trail", payments: "Payments", drawerLinked: "drawer-linked",
      approve: "Approve", approved: "Approved", adjustment: "Adjustment", applyAdj: "Apply",
      adjusted: "Adjusted", recordPayment: "Record payment", pay: "Pay", paymentRecorded: "Payment recorded",
      s_accrued: "accrued", s_approved: "approved", s_paid: "paid",
      m_cash: "Cash (from open drawer)", m_bank_transfer: "Bank transfer", m_credit_card: "Card",
    },
    finance: {
      title: "Bank & Expenses", subtitle: "Expense ledger, bank accounts and cost categories · EUR base · audited",
      expenses: "Expenses", banks: "Bank Accounts", categories: "Categories", report: "Report",
      recordExpense: "Record an expense", category: "Category", amount: "Amount", currency: "Currency",
      date: "Date", paidFrom: "Paid from", bank: "Bank", cashDrawer: "Cash drawer",
      bankAccount: "Bank account", vendor: "Vendor", receiptOptional: "Receipt (optional)",
      add: "Add", catAmountReq: "Category and amount are required", selectBank: "Select a bank account",
      expenseRecorded: "Expense recorded", cancelReason: "Reason for cancelling this expense?",
      expenseCancelled: "Expense cancelled", noExpenses: "No expenses yet", paidFromCol: "Paid from",
      status: "Status", cancelled: "cancelled", active: "active",
      newBankAccount: "New bank account", accountName: "Name", opening: "Opening", create: "Create",
      accountNameReq: "Account name required", accountCreated: "Account created",
      manualTxn: "Manual transaction", account: "Account", deposit: "Deposit", withdrawal: "Withdrawal",
      post: "Post", accountAmountReq: "Account and amount required", txnPosted: "Transaction posted",
      noBankAccounts: "No bank accounts yet", openingShort: "Opening",
      newCategory: "New category", dashboardGroup: "Dashboard group", operating: "Operating", travel: "Travel",
      nameReq: "Name required", categoryAdded: "Category added", group: "Group",
      activate: "Activate", deactivate: "Deactivate", active: "Active", inactive: "Inactive",
      totalExpenses: "Total Expenses", byCategory: "By Category", bySource: "By Bank Account / Source",
      noExpensesRange: "No expenses in range",
    },
    approvals: {
      title: "Discounts & Refunds", subtitle: "Single-approval workflow · no self-approval · no duplicate execution",
      allStatuses: "All statuses", allPatients: "All patients", request: "Request",
      newRequest: "New Request", newRequestDesc: "Requires approval by an authorized approver (not you).",
      patient: "Patient", type: "Type", currency: "Currency", amount: "Amount", reason: "Reason",
      submitRequest: "Submit request", requiredFields: "Patient and amount are required",
      requestSubmitted: "Request submitted", noRequests: "No requests",
      discount: "Discount", refund: "Refund", requestedBy: "Requested by", approvedBy: "approved by",
      executedBy: "executed by", approve: "Approve", execute: "Execute",
      s_pending: "pending", s_approved: "approved", s_executed: "executed", s_rejected: "rejected",
    },
    journey: {
      title: "Patient Journey", subtitle: "Unified operational view · coordination → clinic → lab → travel → transport",
      selectPatient: "Select patient", timeline: "Patient Journey Timeline", noEvents: "No journey events yet.",
    },
    messages: {
      title: "Messages", subtitle: "Secure internal staff messaging", new: "New",
      newConversation: "New Conversation", selectColleague: "Select colleague", start: "Start",
      noConversations: "No conversations", noMessages: "No messages yet", selectConversation: "Select a conversation",
      typeMessage: "Type a message…",
    },
    reports: {
      title: "Reports", subtitle: "Accounting & operational reporting", daily: "Daily",
      monthly: "Monthly Closing", visits: "Visit Durations", noReport: "No report available",
      completedVisits: "Completed visits", totalVisits: "Total visits", avgWaiting: "Avg waiting",
      longestWaiting: "Longest waiting", avgTreatment: "Avg treatment", patient: "Patient", visit: "Visit",
      type: "Type", dentist: "Dentist", scheduled: "Scheduled", arrived: "Arrived", waited: "Waited",
      treatStart: "Treat start", treatDur: "Treat dur.", completed: "Completed",
      noVisits: "No visits for this day", date: "Date", eachIndependent: "Each visit is independent · Synthetic development data.",
      revenueEur: "Revenue (EUR)", cashCollected: "Cash collected", cardCollected: "Card collected",
      refunds: "Refunds", discounts: "Discounts", doctorEarnings: "Doctor earnings",
      technicianEarnings: "Technician earnings", labCosts: "Lab costs", netEur: "Net (EUR)",
      netTry: "Net (TRY statutory)", bankSettlements: "Bank settlements", cashBalance: "Cash balance",
      collectionsByCurrency: "Collections by currency", noPayments: "No payments", txn: "txn",
      posReconciliation: "POS reconciliation", cardPayments: "Card payments", matchedPos: "Matched POS reference",
      missingPos: "Missing POS reference", discrepancies: "Discrepancies", noneDisc: "None", month: "Month",
      ratesToEur: "Rates to EUR", syntheticData: "Synthetic development data.",
    },
    employees: {
      title: "Employees", subtitle: "Individual staff accounts, roles and access control",
      addEmployee: "Add Employee", createAccount: "Create Employee Account",
      createAccountDesc: "A unique one-time activation code is generated. The employee uses it once to set their own private password.",
      username: "Username", fullName: "Full name", email: "Email", role: "Role", selectRole: "Select role",
      createAccountBtn: "Create account", selectRoleErr: "Select a role", employeeCreated: "Employee created",
      accountDeactivated: "Account deactivated · sessions revoked", accountEnabled: "Account enabled",
      mfaReset: "MFA reset", mainCoordApplied: "Main Coordinator profile applied",
      codeIssued: "New activation code issued", name: "Name", status: "Status", mfa: "MFA",
      disabled: "Disabled", active: "Active", pendingActivation: "Pending activation",
      enrolled: "Enrolled", required: "Required", issueCode: "Issue activation code",
      resetMfa: "Reset MFA", makeMainCoord: "Make Main Coordinator", mainCoord: "Main Coordinator ✓",
      deactivate: "Deactivate", activate: "Activate",
      shareSecurely: "Share securely with the employee. Shown only once — they use it to set their own password.",
      activationCode: "Activation code",
      phone: "Phone", phonePlaceholder: "e.g. +90 532 000 00 00",
      edit: "Edit", editAccount: "Edit Employee",
      editAccountDesc: "Update name, email, phone and role. Switching to a privileged role automatically requires MFA.",
      saveChanges: "Save changes", employeeUpdated: "Employee updated",
      rolesLoadError: "Could not load roles. This may be a session or connection issue — please refresh.",
    },
    permissions: {
      title: "Permission Center", subtitle: "Configure exactly what each employee can view, create, edit, approve, execute and export",
      selectEmployee: "Select an employee", editing: "Editing",
      labBlocked: ". Lab roles are permanently blocked from financial data.",
      resource: "Resource", financial: "financial", permissionsUpdated: "Permissions updated · sessions refreshed",
      a_view: "view", a_create: "create", a_edit: "edit", a_approve: "approve",
      a_execute: "execute", a_export: "export",
    },
    audit: {
      title: "Audit & Activity", subtitle: "Every action is attributed to the responsible employee",
      auditLog: "Audit Log", loginHistory: "Login History", permissionChanges: "Permission Changes",
      time: "Time", employee: "Employee", action: "Action", entity: "Entity", ip: "IP",
      username: "Username", result: "Result", success: "Success", failed: "Failed",
      changedBy: "Changed By", targetEmployee: "Target Employee", overrides: "Overrides",
      rules: "rule(s)", noRecords: "No records",
    },
    driver: {
      myTrips: "My Trips", online: "Online", offline: "Offline",
      noTrips: "No trips assigned to you.", hotelNotSet: "Hotel not set",
      pickedUp: "Picked up", delivered: "Delivered", patientPickedUp: "Patient Picked Up",
      patientDelivered: "Patient Delivered", tripCompleted: "Trip completed",
      tripCancelled: "Trip cancelled", pickupRecorded: "Pickup recorded",
      deliveryRecorded: "Delivery recorded — trip complete", offlineErr: "You're offline — reconnect and try again.",
      networkErr: "Network error — please retry.",
      s_scheduled: "Scheduled", s_en_route_pickup: "En route", s_arrived_pickup: "Arrived",
      s_passenger_onboard: "Picked up", s_completed: "Delivered", s_cancelled: "Cancelled",
    },
    notif: {
      title: "Notifications", markAll: "Mark all read", allCaughtUp: "You're all caught up.",
      waiting: "for the dentist", waitingMin: "min for the dentist (over", unassigned: "Unassigned", visit: "Visit",
    },
  },
};
